import React from 'react';

export default function WeekNavigator({ currentWeekStart, onPrevWeek, onNextWeek, stats }) {
    // Determine the end date of the week
    const weekEnd = new Date(currentWeekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);

    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    const displayStr = `${formatDate(currentWeekStart)} - ${formatDate(weekEnd)}${currentWeekStart.getFullYear() !== new Date().getFullYear() ? `, ${currentWeekStart.getFullYear()}` : ''}`;

    return (
        <div style={styles.container}>
            <button onClick={onPrevWeek} style={styles.navBtn}>&lt;</button>
            <div style={styles.centerBlock}>
                <div style={styles.label}>Week View</div>
                <div style={styles.dateStr}>{displayStr}</div>
                <div style={styles.statsStr}>
                    {stats?.shiftsCount || 0} shifts • {stats?.hoursCount?.toFixed(1) || 0} hours
                </div>
            </div>
            <button onClick={onNextWeek} style={styles.navBtn}>&gt;</button>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '16px 24px', backgroundColor: 'white', border: '1px solid #e5e7eb',
        borderRadius: '8px', marginBottom: '16px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
    },
    navBtn: {
        background: 'none', border: 'none', color: '#0056b3', fontSize: '20px', cursor: 'pointer',
        padding: '8px'
    },
    centerBlock: {
        textAlign: 'center'
    },
    label: {
        fontSize: '12px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', fontWeight: '600'
    },
    dateStr: {
        fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '4px'
    },
    statsStr: {
        fontSize: '13px', color: '#0056b3', fontWeight: '500'
    }
};
